import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { HttpService } from '../http.service';
import { MatTableDataSource } from '@angular/material/table';
import { SnackbarService } from '../snackbar.service';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
@Component({
  selector: 'app-add-shortage',
  templateUrl: './add-shortage.component.html',
  styleUrls: ['./add-shortage.component.scss']
})
export class AddShortageComponent implements OnInit {

  isReceivedQuantity: boolean = false;
  twWeigth: any;
  gwWeigth: any;
  twGwWeight: any;
  dataSource: MatTableDataSource<any>;
  mwg =0;

  constructor(@Inject(MAT_DIALOG_DATA) private parentData: any, private dialog: MatDialogRef<AddShortageComponent>, private http: HttpService, private snackBar: SnackbarService, private popup: MatDialog) {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  shipmentID: any;
  displayedColumns = ['sno',
    'invoice',
    'finalFreightRate',
    'shippedQty',
    'shippedNop',
    'receivedQty',
    'receivedNop',
    'epods'
  ];
  invoices = [];
  dialogRef;
  showDetails = false;
  
  ngOnInit(): void {
    this.invoices = this.parentData;
    this.shipmentID = this.parentData[0].shipment_id;
    this.invoices.forEach((inv, i) => {
      const { commercial_invoices, _id } = inv;
      if (!commercial_invoices[0].others.final_freight_rate) {
        this.isReceivedQuantity = true;
      }
      const temp = {
        _id,
        invoice: commercial_invoices[0].num,
        finalFreightRate: commercial_invoices[0].others.final_freight_rate || 0,
        sno: i + 1,
        shippedQty: commercial_invoices[0].net_weight,
        shippedNop: commercial_invoices[0].nop,
        receivedQty: commercial_invoices[0].others.received_quantity || 0,
        receivedNop: commercial_invoices[0].others.received_nop || 0,
        epods: commercial_invoices[0].others.epods || [],
        do: commercial_invoices[0].others.do_number || 'NA',
        invoiceType: commercial_invoices[0].others.invoice_type ||'-',
      };
      this.dataSource.data.push(temp);// Push to dataSource.data instead of dataSource directly
    });
    this.getTwGw();
  }

  addShortages() {
    const payload = {
      shipment: this.shipmentID,
      invoices: this.dataSource.data.map(i => {
        return {
          _id: i._id,
          received_quantity: i.receivedQty,
          received_nop: i.receivedNop
        }
      })
    };
    this.http.post('carrier_invoice/shortageByInvoice', payload, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Received quantity added successfully');
          this.dialog.close();
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  openFileUploader(element) {
    const payload = {
      url: 'v3/shipment/upload_epod/',
      _id: element._id
    };
    this.dialogRef = this.popup.open(FileUploaderComponent, {
      data: payload
    });
    this.dialogRef.afterClosed().subscribe(
      (data: any) => {
        
      }
    )
  }

  handleGetFreight(val) {
    const index = val.sno - 1
     const payload = {
      shipment: this.shipmentID,
      do_number: val.do,
      invoice:val._id,
      first: index == 0 ? true : false
    }
     this.http.get('freight_rate/get',payload,1).subscribe((data:any)=>{
      const updatedData = this.dataSource.data.map((element, i) => {
        if (i === index) {
          return { ...element, finalFreightRate: data.data };
        }
        return element;
      });
      // Assign the updated data back to the dataSource
      this.dataSource.data = updatedData;
      let flag = false
      this.dataSource.data.map((element)=>{
        if(element.finalFreightRate === 0) {
          flag = true
        } 
      })
      this.isReceivedQuantity = flag
      this.snackBar.openSnackBar('Freight rate fetched successfully');
     },(err:any)=>{
      this.snackBar.openSnackBar("Something went wrong, Try again!",'', 'err')
     })
  }


  cancelInvoice(invoice) {
    const payload = {
      _id: this.shipmentID,
      invoice,
    };
    this.http.post('invoice/cancel', payload, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Invoice cancelled successfully');
          this.dialog.close();
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  downloadEpods(epods) {
    
    const urls = epods;
    for (let link of urls) {
      window.open(link, '_blank');
    }
  }
  getTwGw() {
    console.log("this.shipmentID", this.shipmentID)
    const payload = {
      shipment: this.shipmentID,
    }
    this.http.get('v1/getTwGwWeight', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.twGwWeight = data.data;
          const result= data.data;
          result.forEach(i => {
            if(i.event_name === 'TW') this.twWeigth = (i.weight)/1000;
            else this.gwWeigth = (i.weight)/1000;
          })
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      });
  }
}
